export enum SOCKET_NAMESPACES {
    REMOTE_CONFIG = "remote-config",
    USER_STATUS = "user-status",
}
